import IS_CLIENT_RENDERED from "./isClientRendered";

const windowDataLayer = {
  push: payload => {
    if (IS_CLIENT_RENDERED) {
      window.dataLayer.push(payload);
    }
  },
};

export default windowDataLayer;



// WEBPACK FOOTER //
// ./src/util/windowDataLayer.js